import React from 'react';
import * as Yup from 'yup';
import { Box, Button, Grid, MenuItem } from '@mui/material';
import { Form, Formik } from 'formik';
import CustomSelectForm from '../../components/forms/CustomSelectForm';
import { useSelector } from 'react-redux';
import { map } from 'lodash';

// ################### validation schema ###############
const addProductOnPromotionSchema = Yup.object({
  promotion: Yup.string('Promotion must be a string type').required(),
});

const AddProductOnPromotion = ({ product_id }) => {
  const promotions = useSelector((state) => state.promotions.promotions);

  return (
    <>
      <Formik
        initialValues={{
          promotion: '',
        }}
        validationSchema={addProductOnPromotionSchema}
        onSubmit={async (values) => {
          const payload = {
            ...values,
            product_id,
          };
          console.log(payload);
        }}
      >
        {(formik) => (
          <Form>
            <Grid container spacing={2} justifyContent={'center'}>
              <Grid item sm={12}>
                <CustomSelectForm
                  name="promotion"
                  formikName="promotion"
                  label="Select promotion"
                  formik={formik}
                >
                  {map(promotions, ({ promotion_name, id }) => (
                    <MenuItem value={id}>{promotion_name}</MenuItem>
                  ))}
                </CustomSelectForm>
              </Grid>
              <Grid item sm={12}>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Button
                    variant="contained"
                    className="app-btn"
                    color="secondary"
                    onClick={formik.handleSubmit}
                  >
                    Add product to promotion
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddProductOnPromotion;
